import { PureComponent, ReactNode } from "react";
import { Modal } from "../../components";
import { IStoreState } from "../../store/states";
import { DispatchProp } from "react-redux";
import { connectRedux } from '../../helpers/connectRedux'
import { ISeat, IStop } from "../../models";
import React from "react";
import { LiteralsService } from "../../services";
import moment from "moment";
import { images } from "../../images";
import StyledDiv from './styles'
import { setQrCodeAndDetails } from "../../store/actions";
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<any> {
  qrCode: string,
  beginningStop: IStop
  seats: ISeat[]
}

interface IState {
  showQR: boolean
}

class QrModal extends PureComponent<IProps, IState> {
  private get modalContent(): ReactNode {
    const { qrCode, beginningStop, seats } = this.props
    const normalSeats = seats.filter(s => !s.prm).length
    const prmSeats = seats.filter(s => s.prm).length

    return (
      <div className="content">
        <img src={ `data:image/png;base64,${ qrCode }` } alt="qr_code"/>
        <div className="reservation-details">
          <span className="datetime-details">
            { LiteralsService.get(moment(beginningStop?.dateTime).locale('en').format('dddd').toLowerCase(), true) }
            { `, ${moment(beginningStop?.dateTime).format(' D ')}` }
            { LiteralsService.get(moment(beginningStop?.dateTime).locale('en').format('MMMM').toLowerCase()) }
            { ` - ${moment(beginningStop?.dateTime).format('HH').toLowerCase()}:${moment(beginningStop?.dateTime).format('mm').toLowerCase()}h` }
          </span>
          {
            normalSeats > 0 &&
            <span className="seats-details">
              { `${normalSeats} ${LiteralsService.get('seat')}` }
            </span>
          }
          {
            prmSeats > 0 &&
            <span className="seats-details">
              { `${prmSeats} ${LiteralsService.get('prmSeat')}` }
            </span>
          }
        </div>
      </div>
    )
  }

  constructor(props: IProps) {
    super(props)

    this.state = {
      showQR: false
    }
  }

  componentDidUpdate(): void {
    const { qrCode } = this.props

    this.setState({
      showQR: qrCode === null ? false : true
    })
  }

  public render() {
    const { showQR } = this.state
    
    if (!showQR) return null
    return (
      <Modal isHidden={ false } onOverlayClick={ this.handleClose }>
        <StyledDiv>
          <header>
            <span>
              { LiteralsService.get('ticket', true) }
            </span>
            <img src={ images['cross'] } alt="close" onClick={ this.handleClose } />
          </header>
          { this.modalContent }
        </StyledDiv>
      </Modal>
    )
  }

  private handleClose = () => {
    const { dispatch } = this.props

    dispatch(setQrCodeAndDetails(null))
  }

}

const mapStateToProps = ({ reservations }: IStoreState) => ({
  qrCode: reservations.qrCode,
  beginningStop: reservations.beginningStop,
  seats: reservations.seats
})

export default connectRedux(mapStateToProps, QrModal as any)